import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton, EuiHideFor, EuiShowFor } from '@elastic/eui';
import TableTechSpecs from 'components/Outdoor_Cameras/IN-4011/Technical_Specifications/Table';
import NavButtons from 'components/Outdoor_Cameras/IN-4011/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  EuiHideFor,
  EuiShowFor,
  TableTechSpecs,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};